export const isLoading = (state) => state.loadingGlobal

export const datos = (state) => state.datos

export const selectedProduct = (state) => state.selectedProduct

export const iniciarReclamo = (state) => state.reclamoAutomatico

export const dataVtex = (state) => (state.dataVtex ? state.dataVtex : false)

export const fechaEntrega = (state) => (state.fechaEntrega ? state.fechaEntrega : false)
export const enTiempo     = (state) => (state.enTiempo ? state.enTiempo : false)
// export const dias30     = (state) => (state.dias30 ? state.dias30 : false)

export const numeroCaso     =  ( state ) => {
    return state.numeroCaso ? state.numeroCaso : state.datos.datos_reclamo.length > 0 ? state.datos.datos_reclamo[0].number_case : -1
}



export const pedidoCancelado=  ( state ) => state.pedidoCancelado

export const textoCancelandoPedido=  ( state ) => state.textoCancelandoPedido

export const estadoCaso     =  ( state ) => state.estadoCaso

export const messages       =  ( state ) => state.messages



export const cabecera = (state) => (state.datos ? (state.datos.reclamo ? state.datos.reclamo : false) : false)



export const verMensajes = (state) => {
	return state.datos ? (state.datos.datos_reclamo.length > 0 ? (state.datos.datos_reclamo[0].estado == 'C' ? false : true) : false) : false
}

export const mostrarChat    = ( state ) => state.mostrarChat

export const getArrepentido    = ( state ) => state.arrepentido

export const mostrarInput   =  ( state ) => state.datos ? state.datos.datos_reclamo.length > 0 ? state.datos.datos_reclamo[0].estado : false : false

